<template>
  <div class="login">
    <div class="logo">
      <img
        src="../assets/logo-white.svg"
        alt="In Rewards"
      >
    </div>
    <div class="content">
      <h1>Sign in to in rewards admin</h1>
      <a-form
        :model="user"
        @submit="login"
      >
        <a-form-item>
          <a-input
            v-model:value="user.name"
            placeholder="User Name"
            size="large"
            :rules="[{ required: true, message: 'Please enter your name!' }]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            v-model:value="user.password"
            placeholder="Password"
            size="large"
            type="password"
            :rules="[
              { required: true, message: 'Please enter your password!' },
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            class="login-btn"
            type="primary"
            html-type="submit"
            size="large"
            :loading="loading"
          >
            Sign in
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { loginApi } from '../server/index'
import { message } from 'ant-design-vue'
import '../assets/login-text-bg.svg'

export default {
  data() {
    return {
      loading: false,
      user: {
        name: '',
        password: '',
      },
    }
  },
  mounted() {},
  methods: {
    login() {
      if (this.loading) return
      this.loading = true
      loginApi
        .loginUser({
          name: this.user.name,
          password: this.user.password,
        })
        .then((res) => {
          if (res && res.success) {
            const time = new Date().getTime()
            localStorage.setItem(
              'adminToken',
              res.data.name + '|' + res.data.editorToken
            )
            localStorage.setItem('tokenTime', time)
            location.href = '/#/advertisers'
          } else {
            message.error((res && res.error) || '登录失败，请重试')
          }
        })
        .catch((err) => {
          const msg =
            err.code === 'ECONNABORTED'
              ? '请求超时，请检查网络或 vue.config.js 中的 API 代理地址'
              : err.message || '网络异常，请稍后重试'
          message.error(msg)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  position: relative;
  background: linear-gradient(-61deg, #979578 0%, #5e5c43 100%);
  &:before {
    top: 50%;
    left: 0px;
    z-index: 2;
    content: '';
    right: -10px;
    bottom: -15px;
    opacity: 0.04;
    font-size: 300px;
    font-weight: 500;
    position: absolute;
    background: url('../assets/login-text-bg.svg') no-repeat center bottom;
    background-size: 100% auto;
  }
  &:after {
    left: 0;
    top: 56%;
    right: 0;
    bottom: 0;
    z-index: 1;
    content: '';
    opacity: 0.04;
    position: absolute;
    background: #000;
  }
  &-btn {
    width: 100%;
    font-size: 16px;
  }
  .logo > img {
    width: 180px;
    margin-top: 20px;
    margin-left: 20px;
  }
}
.content {
  top: 45%;
  left: 50%;
  z-index: 3;
  width: 450px;
  min-width: auto;
  overflow: hidden;
  border-radius: 0;
  padding: 20px 10px;
  position: absolute;
  background: #fff;
  transform: translate(-50%, -50%);
  > h1 {
    margin: 0 -30px;
    font-size: 30px;
    line-height: 50px;
    color: #5e5c43;
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(94, 92, 67, 0.1);
  }
  :deep(.ant-form) {
    padding: 0 30px;
    margin-top: 40px;
    &-item {
      &-label > label {
        width: 63px;
        display: block;
        font-size: 16px;
      }
      &-control-wrapper {
        flex: 1;
      }
    }
    .ant-input {
      box-shadow: none;
      border-radius: 0;
      border-color: rgba(94, 92, 67, 0.2);
      &:focus,
      &:hover {
        border-color: rgba(94, 92, 67, 0.4);
      }
    }
    .ant-btn {
      box-shadow: none;
      border-radius: 0;
      background-color: rgba(94, 92, 67);
      &:hover {
        background-color: rgba(94, 92, 67, 0.9);
      }
    }
  }
}
</style>